
import React from 'react'
import { Toolbar } from '@mui/material'
import './Skills.css'
import { SkillsHeading, SkillsList } from '../../components/Comp/AllComponents';
const Skills = () => {
    return (
        <>

            <SkillsHeading />
            <Toolbar /> <div className="mainSkills ">
            {
                SkillsList.map((skills, index) => (
                   
                        <div key={index} className="SkillsCard">
                            <div className="align">
                                <span className='red'></span>
                                <span className='yellow'></span>
                                <span className='green'></span>
                            </div>

                            <img src={skills.image} alt="" />
                            <p >{skills.description}</p>

                        </div>
                    
                ))
            }
</div>

            <Toolbar />
        </>
    )
}

export default Skills
